window.addEventListener('load', function () {
  setTimeout(function () {
    document.documentElement.classList.add('dftb-animations-ready');
  }, 200);

  var desktopHover = window.matchMedia('(min-width: 769px) and (hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference)');

  document.querySelectorAll('.site-header__logo').forEach(function (logo) {
    function startLogoSwing() {
      if (desktopHover.matches && !logo.classList.contains('dftb-logo-swinging')) {
        logo.classList.add('dftb-logo-swinging');
      }
    }

    function finishLogoSwing(event) {
      if (event.target === logo && event.animationName === 'dftb-sign-swing') {
        logo.classList.remove('dftb-logo-swinging');
      }
    }

    logo.addEventListener('pointerenter', startLogoSwing);
    logo.addEventListener('focusin', startLogoSwing);
    logo.addEventListener('animationend', finishLogoSwing);
    logo.addEventListener('animationcancel', finishLogoSwing);
  });
});
